export function switchLanguage(locale) {
    return {
        type: '@settings/SWITCH_LANGUAGE',
        payload: { locale },
    };
}
